import { Alert, Divider, Chip, Box, Grid2, Button, Typography, Card, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, IconButton, InputAdornment, Paper, Snackbar, Stack, TextField, Tooltip, CardHeader, Menu, MenuItem, Link } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { isStudent, isTrial, useAuth } from "../../contexts/AuthContext";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

//import { useNavigate } from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import DeleteIcon from '@mui/icons-material/Delete';
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase } from "../../config/apiBase";
import { useNavigate } from "react-router-dom";
import {
    Block,
    CheckCircle,
    Edit as EditIcon,
} from '@mui/icons-material';
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import LockIcon from "@mui/icons-material/Lock";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AsyncButton from "../../components/common/AsyncButton";
import { useAsyncAction } from "../../components/common/useAsyncAction";




const Enroll = () => {
    //const navigate = useNavigate();
    const { user, logout, refreshUser } = useAuth();
    const isTrialState = isTrial();
    const isStudentState = isStudent();
    const navigate = useNavigate();
    const enrollSectionRef = useRef(null);
    const studentsSectionRef = useRef(null);

    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const [tourOpen, setTourOpen] = useState(false);
    const [tourSection, setTourSection] = useState(0);
    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const [dialog, setDialog] = useState({ open: false, user: false, group: false, id: "", button: "", content: "" })
    const { run: runDialog, loading: dialogSubmitting } = useAsyncAction();

    const handleDialogClose = () => {
        setDialog({ open: false })
    }

    const tourSections = isStudentState
        ? [
            {
                title: "Enrolled Student(s)",
                description: "View students, check status, and use activate, edit, or delete actions.",
                targetRef: studentsSectionRef,
            },
        ]
        : [
            {
                title: "Enroll Student",
                description: "Fill general and login details, then click Enroll to create a student account.",
                targetRef: enrollSectionRef,
            },
            {
                title: "Enrolled Student(s)",
                description: "Manage enrolled students and use activate, edit, or delete actions. You can also see the account status for each student.",
                targetRef: studentsSectionRef,
            },
        ];

    const startTour = () => {
        setTourSection(0);
        setTourOpen(true);
    };

    const closeTour = () => {
        setTourOpen(false);
    };

    const goToTourSection = (nextSection) => {
        if (nextSection < 0) return;
        if (nextSection >= tourSections.length) {
            closeTour();
            return;
        }
        setTourSection(nextSection);
    };

    useEffect(() => {
        if (!tourOpen) return;
        const target = tourSections[tourSection]?.targetRef?.current;
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [tourOpen, tourSection]);

    const handleDialogContinue = async () => {
        await runDialog(async () => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/unenroll`,
                {
                    "ID": dialog.id,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            setDialog({ open: false })
            setState({ open: true, severity: "success", message: "User deleted successfully" })
            refreshUser();
        });
    }

    const RenderAddStudent = () => {
        const [loginData, setLoginData] = useState({
            firstname: '',
            lastname: '',
            username: '',
            password: '',
            isactive: false,
        });


        const handlePasswordChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            setLoginData({ ...loginData, [name]: value });
        };

        const [showPassword, setShowPassword] = useState(false);
        const { run: runEnroll, loading: enrollSubmitting } = useAsyncAction();
        const handleClickShowPassword = () => setShowPassword((show) => !show);

        const handleMouseDownPassword = (event) => {
            event.preventDefault();
        };

        const handleMouseUpPassword = (event) => {
            event.preventDefault();
        };

        const handleEnroll = async (event) => {
            event.preventDefault();
            /*TODO: Check all parameters else error out! */
            if (loginData.username === "" || loginData.password === "" || loginData.firstname === "" || loginData.lastname === "") {
                setState({ open: true, severity: "error", message: "Please fill in all the required fields" })
                return
            }
            await runEnroll(async () => {
                const status = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enroll`,
                    {
                        "Username": loginData.username,
                        "Password": loginData.password,
                        "FirstName": loginData.firstname,
                        "LastName": loginData.lastname,
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if (isTrialState && status.unauthorized) {
                    setState({ open: true, severity: "error", message: "You cannot create more than 2 inactive users" })
                    navigate("/app/activate")
                }
                if (status["unauthenticated"] == true || status["unauthorized"] == true) {
                    logout(user);
                }
                if (status.alreadyExists) {
                    setState({ open: true, severity: "warning", message: "Username already exists" })
                } else {
                    console.log(status)
                    setState({ open: true, severity: "success", message: "User enrolled successfully" })
                }
            });
        };

        return (

            <Box variant="outlined" sx={{ marginBottom: "20px" }} >
                <form>
                    <Card 
                        elevation={6}
                        sx={{
                            borderRadius: 4,
                            border: '1px solid',
                            borderColor: 'divider',
                            backgroundColor: 'background.paper',
                            boxShadow: (theme) => theme.palette.mode === 'dark'
                                ? '0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                    ? '0 8px 24px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.15)'
                                    : '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                transform: 'translateY(-2px)',
                            },
                        }}
                    >
                        <CardHeader 
                            sx={{ 
                                textAlign: 'center', 
                                pb: 1,
                            }}
                            title={
                                <Typography 
                                    sx={{ 
                                        fontWeight: 600,
                                        fontSize: '1.125rem',
                                        color: 'text.primary',
                                        letterSpacing: '-0.01em',
                                        textAlign: 'center',
                                        width: '100%'
                                    }} 
                                    variant="h6"
                                >
                                    Enroll Student
                                </Typography>
                            } 
                        />
                        <CardContent>
                            <Stack>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Grid2 container spacing={6} justifyContent="center" sx={{ width: '100%' }}>
                                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>

                                            <Stack sx={{ width: '100%', maxWidth: '50ch' }}>
                                                <h3 style={{ textAlign: 'center' }}>General Details:</h3>
                                                <Box display="flex" alignItems="center" gap={1} mb={2}>
                                                    <PersonIcon sx={{ color: "black" }} />
                                                    <TextField
                                                        label="First Name"
                                                        variant="outlined"
                                                        name="firstname"
                                                        required
                                                        sx={{ m: 1, width: '50ch', verticalAlign: 'middle' }}
                                                        autoComplete="true"
                                                        onChange={handlePasswordChange}
                                                        value={loginData.firstname}
                                                    />
                                                </Box>
                                                <Box display="flex" alignItems="center" gap={1} mb={2}>
                                                    <BadgeIcon sx={{ color: "purple" }} />
                                                    <TextField
                                                        label="Last Name"
                                                        variant="outlined"
                                                        name="lastname"
                                                        required
                                                        sx={{ m: 1, width: '50ch', verticalAlign: 'middle' }}
                                                        autoComplete="true"
                                                        onChange={handlePasswordChange}
                                                        value={loginData.lastname}
                                                    />
                                                </Box>
                                            </Stack>
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Stack sx={{ width: '100%', maxWidth: '50ch' }}>
                                                <h3 style={{ textAlign: 'center' }}>Login Details:</h3>
                                                <Box display="flex" alignItems="center" gap={1} mb={2}>
                                                    <AccountCircleIcon color="primary" />
                                                    <TextField
                                                        label="User Name"
                                                        variant="outlined"
                                                        name="username"
                                                        required
                                                        sx={{ m: 1, width: '50ch', verticalAlign: 'middle' }}
                                                        autoComplete="true"
                                                        onChange={handlePasswordChange}
                                                        value={loginData.username}
                                                    />
                                                </Box>
                                                <Box display="flex" alignItems="center" gap={1} mb={2}>
                                                    <LockIcon sx={{ color: "orange" }} />
                                                    <TextField
                                                        id="outlined-adornment-password"
                                                        type={showPassword ? 'text' : 'password'}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label={
                                                                                showPassword ? 'hide the password' : 'display the password'
                                                                            }
                                                                            onClick={handleClickShowPassword}
                                                                            onMouseDown={handleMouseDownPassword}
                                                                            onMouseUp={handleMouseUpPassword}
                                                                            edge="end"
                                                                        >
                                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                        label="Password"
                                                        name="password"
                                                        onChange={handlePasswordChange}
                                                        required
                                                        sx={{ m: 1, width: '50ch', verticalAlign: 'middle' }}
                                                    />
                                                </Box>
                                            </Stack>
                                        </Grid2>
                                    </Grid2>


                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center" sx={{ paddingTop: "10px" }}>
                                    <AsyncButton sx={{ textTransform: "initial" }} type="submit" variant="contained" color="primary" onClick={handleEnroll} loading={enrollSubmitting}>
                                        Enroll
                                    </AsyncButton>
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center" sx={{ paddingTop: "10px", textAlign: "center" }}>
                                    <Typography variant="body2" color="text.secondary">
                                        By clicking enroll button you agree to our{" "}
                                        <Link
                                            sx={{ color: "primary.main", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                                            href="/tnc"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Terms of Use
                                        </Link>
                                    </Typography>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>


                </form>
            </Box>
        )
    }

    const RenderAddedStudents = () => {
        const [studentData, setStudentData] = useState([]);
        const [activationStatusMap, setActivationStatusMap] = useState({});

        const getUserData = async () => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enrolled`,
                { "EnrollerID": user["id"] },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response["EnrolledUsers"]
        }

        const getActivationStatusForUsers = async (users) => {
            const statusMap = {};
            // Check activation status for each inactive user
            const inactiveUsers = users.filter(user => !user.IsActive);
            
            await Promise.all(
                inactiveUsers.map(async (userData) => {
                    try {
                        const response = await InvokeAPI(
                            `${getUserMgmtBase()}/v1/user/enroll/activation-status`,
                            {
                                "UserID": userData.ID,
                            },
                            'POST',
                            { "authorization": user["token"] },
                            false
                        )
                        if (response["unauthenticated"] == true || response["unauthorized"] == true || response["othererror"] == true) {
                            return;
                        }
                        if (response.response && response.response["IsInProgress"] === true) {
                            statusMap[userData.ID] = true;
                        }
                    } catch (error) {
                        // Silently handle errors for individual status checks
                    }
                })
            );
            return statusMap;
        }

        useEffect(() => {
            //Some function
            getUserData().then(data => {
                setStudentData(data);
                // Check activation status for all inactive users
                getActivationStatusForUsers(data).then(statusMap => {
                    setActivationStatusMap(statusMap);
                });
            })
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])



        const activateUser = async (userID) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enroll/activate`,
                {
                    "UserID": userID,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            getUserData().then(data => {
                setStudentData(data);
                // Refresh activation status after activation
                getActivationStatusForUsers(data).then(statusMap => {
                    setActivationStatusMap(statusMap);
                });
            })
            setState({ open: true, severity: "success", message: "User activation initiated successfully. We will send an email when the account is activated." })
        }

        function handleActivate(userID) {
            //console.log(userID)
            activateUser(userID)
            refreshUser()
        }

        const deleteUser = async (userID) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/unenroll`,
                {
                    "ID": userID,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            getUserData().then(data => {
                setStudentData(data);
                // Refresh activation status after deletion
                getActivationStatusForUsers(data).then(statusMap => {
                    setActivationStatusMap(statusMap);
                });
            })
            setState({ open: true, severity: "success", message: "User deleted successfully" })
            refreshUser()
        }

        function handleDelete(userID) {
            //console.log(userID)
            deleteUser(userID)
        }

        return (
            <Box sx={{ paddingRight: "5px" }}>
                <Card 
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        backgroundColor: 'background.paper',
                        boxShadow: (theme) => theme.palette.mode === 'dark'
                            ? '0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                            : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: (theme) => theme.palette.mode === 'dark'
                                ? '0 8px 24px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.15)'
                                : '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader 
                        sx={{ 
                            textAlign: 'center', 
                            pb: 1,
                        }}
                        title={
                            <Typography 
                                sx={{ 
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }} 
                                variant="h6"
                            >
                                Enrolled Student(s)
                            </Typography>
                        } 
                    />
                    <CardContent>
                        <br></br>
                        <Grid2 container spacing={3}>

                            {studentData && studentData.map((row) => (
                                <Grid2 key={row.ID} size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Card
                                        elevation={6}
                                        sx={{
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            position: 'relative',
                                            borderRadius: 3,
                                            paddingRight: "5px",
                                            paddingLeft: "5px",
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            backgroundColor: 'background.paper',
                                            boxShadow: (theme) => theme.palette.mode === 'dark'
                                                ? '0 2px 8px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                                : '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            '&:hover': {
                                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                                    ? '0 8px 24px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.15)'
                                                    : '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                                transform: 'translateY(-4px)',
                                            }
                                        }}
                                    >

                                        <CardContent>
                                            {/* Top row: Username on left, Status on right */}
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Typography 
                                                    variant="h6" 
                                                    sx={{
                                                        fontWeight: 500,
                                                        fontSize: '1rem',
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        flex: 1,
                                                        mr: 1
                                                    }}
                                                >
                                                    {row.Username}
                                                </Typography>
                                                <Chip
                                                    icon={
                                                        <Box
                                                            sx={{
                                                                width: 10,
                                                                height: 10,
                                                                borderRadius: '50%',
                                                                backgroundColor: row.IsActive ? 'success.main' : 'error.main',
                                                                boxShadow: row.IsActive 
                                                                    ? '0 0 0 2px rgba(46, 125, 50, 0.2)' 
                                                                    : '0 0 0 2px rgba(211, 47, 47, 0.2)',
                                                            }}
                                                        />
                                                    }
                                                    label={row.IsActive ? 'Active' : 'Inactive'}
                                                    size="small"
                                                    sx={{
                                                        fontWeight: 600,
                                                        fontSize: '0.75rem',
                                                        height: '28px',
                                                        backgroundColor: row.IsActive 
                                                            ? 'rgba(46, 125, 50, 0.1)' 
                                                            : 'rgba(211, 47, 47, 0.1)',
                                                        color: row.IsActive ? 'success.main' : 'error.main',
                                                        border: '1.5px solid',
                                                        borderColor: row.IsActive ? 'success.main' : 'error.main',
                                                        '& .MuiChip-icon': {
                                                            marginLeft: '8px',
                                                            marginRight: '-4px',
                                                        },
                                                        '& .MuiChip-label': {
                                                            paddingLeft: '8px',
                                                            paddingRight: '12px',
                                                        }
                                                    }}
                                                />
                                            </Box>

                                            {/* First Name and Last Name */}
                                            <Box sx={{ mb: 2 }}>
                                                {row.FirstName !== "" && (
                                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        First Name: {row.FirstName}
                                                    </Typography>
                                                )}
                                                {row.LastName !== "" && (
                                                    <Typography variant="body2" color="text.secondary">
                                                        Last Name: {row.LastName}
                                                    </Typography>
                                                )}
                                            </Box>

                                            {/* Bottom row: Activate (if inactive), Edit, and Delete buttons */}
                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '100%' }}>
                                                {row.IsActive == false && (
                                                    activationStatusMap[row.ID] ? (
                                                        <Chip
                                                            label="Activation In Progress"
                                                            color="info"
                                                            size="small"
                                                            sx={{
                                                                fontWeight: 600,
                                                                borderRadius: 2,
                                                                flex: 1,
                                                            }}
                                                        />
                                                    ) : (
                                                        <Button 
                                                            sx={{ 
                                                                textTransform: "initial",
                                                                fontWeight: 500,
                                                                fontSize: '0.875rem',
                                                                borderRadius: 1.5,
                                                                px: 1.5,
                                                                py: 0.75,
                                                                flex: 1,
                                                                background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                                                boxShadow: '0 1px 4px rgba(46, 125, 50, 0.3)',
                                                                border: '1.5px solid',
                                                                borderColor: 'success.main',
                                                                '&:hover': {
                                                                    background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                                                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.4)',
                                                                    transform: 'translateY(-1px)',
                                                                    borderColor: 'success.dark',
                                                                }
                                                            }} 
                                                            type="submit" 
                                                            variant="contained" 
                                                            color="success" 
                                                            onClick={(e) => { e.preventDefault(), navigate("/app/activate/"+row.ID) }}
                                                        >
                                                            Activate
                                                        </Button>
                                                    )
                                                )}
                                                
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={() => { navigate('/app/enroll/edit/' + row.ID, { replace: false }) }}
                                                    sx={{
                                                        textTransform: "initial",
                                                        fontWeight: 500,
                                                        fontSize: '0.875rem',
                                                        borderRadius: 1.5,
                                                        px: 1.5,
                                                        py: 0.75,
                                                        flex: 1,
                                                        border: '1.5px solid',
                                                        borderColor: 'primary.main',
                                                        backgroundColor: 'background.paper',
                                                        color: 'primary.main',
                                                        boxShadow: '0 1px 4px rgba(25, 118, 210, 0.15)',
                                                        transition: 'all 0.2s ease-in-out',
                                                        '&:hover': {
                                                            transform: 'translateY(-1px)',
                                                            boxShadow: '0 2px 8px rgba(25, 118, 210, 0.25)',
                                                            backgroundColor: 'primary.main',
                                                            color: 'primary.contrastText',
                                                            borderColor: 'primary.dark',
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            fontSize: '1rem',
                                                        }
                                                    }}
                                                >
                                                    <EditIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Edit
                                                </Button>
                                                
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setDialog({
                                                            open: true,
                                                            id: row.ID,
                                                            button: "Delete User",
                                                            content: "Are you sure you want to delete the user " + row.Username + " ?"
                                                        });
                                                    }}
                                                    sx={{
                                                        textTransform: "initial",
                                                        fontWeight: 500,
                                                        fontSize: '0.875rem',
                                                        borderRadius: 1.5,
                                                        px: 1.5,
                                                        py: 0.75,
                                                        flex: 1,
                                                        border: '1.5px solid',
                                                        borderColor: 'error.main',
                                                        backgroundColor: 'background.paper',
                                                        color: 'error.main',
                                                        boxShadow: '0 1px 4px rgba(211, 47, 47, 0.15)',
                                                        transition: 'all 0.2s ease-in-out',
                                                        '&:hover': {
                                                            transform: 'translateY(-1px)',
                                                            boxShadow: '0 2px 8px rgba(211, 47, 47, 0.25)',
                                                            backgroundColor: 'error.main',
                                                            color: 'error.contrastText',
                                                            borderColor: 'error.dark',
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            fontSize: '1rem',
                                                        }
                                                    }}
                                                >
                                                    <DeleteIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Delete
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid2>
                            ))}


                        </Grid2>
                    </CardContent>
                </Card>
                
                <TableContainer sx={{ display: "none" }} component={Paper}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>UserName</StyledTableCell>
                                <StyledTableCell>First Name</StyledTableCell>
                                <StyledTableCell >Last Name</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {studentData && studentData.map((row) => (
                                <StyledTableRow key={row.Username}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.Username} &nbsp;
                                        {row.IsActive == false ? (
                                            <>
                                                {activationStatusMap[row.ID] ? (
                                                    <Chip
                                                        label="Activation In Progress"
                                                        color="info"
                                                        size="small"
                                                        sx={{
                                                            fontWeight: 600,
                                                            borderRadius: 2,
                                                            ml: 1,
                                                        }}
                                                    />
                                                ) : (
                                                    <Button
                                                        sx={{
                                                            padding: "6px 16px",
                                                            textTransform: "initial",
                                                            fontWeight: 600,
                                                            borderRadius: 2,
                                                            background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                                            boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                                                            border: '2px solid',
                                                            borderColor: 'success.main',
                                                            '&:hover': {
                                                                background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                                                boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                                                                transform: 'translateY(-1px)',
                                                                borderColor: 'success.dark',
                                                            }
                                                        }}
                                                        type="submit"
                                                        variant="contained"
                                                        color="success"
                                                        onClick={(e) => { e.preventDefault(), handleActivate(row.ID) }}
                                                    >
                                                        Activate
                                                    </Button>
                                                )}
                                                &nbsp; &nbsp;
                                            </>
                                        ) : (<></>)}
                                        <Button 
                                            type="submit" 
                                            size="small"
                                            variant="outlined" 
                                            color="primary" 
                                            sx={{
                                                textTransform: "initial",
                                                fontWeight: 500,
                                                fontSize: '0.875rem',
                                                borderRadius: 1.5,
                                                px: 1.5,
                                                py: 0.75,
                                                minWidth: 'auto',
                                                border: '1.5px solid',
                                                borderColor: 'primary.main',
                                                backgroundColor: 'background.paper',
                                                color: 'primary.main',
                                                boxShadow: '0 1px 4px rgba(25, 118, 210, 0.15)',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    transform: 'translateY(-1px)',
                                                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.25)',
                                                    backgroundColor: 'primary.main',
                                                    color: 'primary.contrastText',
                                                    borderColor: 'primary.dark',
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: '1rem',
                                                }
                                            }}
                                            onClick={() => { navigate('/app/enroll/edit/' + row.ID, { replace: false }) }} 
                                        >
                                            <EditIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Edit
                                        </Button>
                                        &nbsp;
                                        <Button 
                                            type="submit" 
                                            size="small"
                                            variant="outlined" 
                                            color="error" 
                                            sx={{
                                                textTransform: "initial",
                                                fontWeight: 500,
                                                fontSize: '0.875rem',
                                                borderRadius: 1.5,
                                                px: 1.5,
                                                py: 0.75,
                                                minWidth: 'auto',
                                                border: '1.5px solid',
                                                borderColor: 'error.main',
                                                backgroundColor: 'background.paper',
                                                color: 'error.main',
                                                boxShadow: '0 1px 4px rgba(211, 47, 47, 0.15)',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    transform: 'translateY(-1px)',
                                                    boxShadow: '0 2px 8px rgba(211, 47, 47, 0.25)',
                                                    backgroundColor: 'error.main',
                                                    color: 'error.contrastText',
                                                    borderColor: 'error.dark',
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: '1rem',
                                                }
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                //handleDelete(row.ID) 
                                                setDialog({
                                                    open: true,
                                                    id: row.ID,
                                                    button: "Delete User",
                                                    content: "Are you sure you want to delete the user " + row.Username + " ?"
                                                })
                                            }} 
                                        >
                                            <DeleteIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Delete
                                        </Button>
                                    </StyledTableCell>
                                    <StyledTableCell >{row.FirstName}</StyledTableCell>
                                    <StyledTableCell >{row.LastName}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )
    }

    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px', backgroundColor: 'background.default', minHeight: '100vh' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={1000}
            >
                <Alert variant="filled" severity={state.severity}>
                    {state.message}
                </Alert>
            </Snackbar>
            <Dialog
                open={dialog.open}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialog.content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <AsyncButton onClick={handleDialogContinue} loading={dialogSubmitting}>
                        {dialog.button}
                    </AsyncButton>
                    <Button onClick={handleDialogClose} autoFocus disabled={dialogSubmitting}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ display: "flex", justifyContent: "right", alignItems: "right", px: 0.5, mb: 1 }}>
                <Button variant="outlined" onClick={startTour}>
                    Take a tour
                </Button>
            </Box>
            <Stack style={{ margin: "0px" }}>
                {isStudentState ? (<></>) : (
                    <Box
                        ref={enrollSectionRef}
                        sx={{
                            borderRadius: 2,
                            border: "1px solid",
                            borderColor: tourOpen && tourSection === 0 ? "primary.main" : "transparent",
                            boxShadow: tourOpen && tourSection === 0 ? "0 0 0 3px rgba(25,118,210,0.25)" : "none",
                            transition: "all 0.2s ease-in-out",
                        }}
                    >
                        <RenderAddStudent />
                    </Box>
                )}
            </Stack>
            <br></br>
            <Stack>
                <Box
                    ref={studentsSectionRef}
                    sx={{
                        borderRadius: 2,
                        border: "1px solid",
                        borderColor: tourOpen && tourSection === (isStudentState ? 0 : 1) ? "primary.main" : "transparent",
                        boxShadow: tourOpen && tourSection === (isStudentState ? 0 : 1) ? "0 0 0 3px rgba(25,118,210,0.25)" : "none",
                        transition: "all 0.2s ease-in-out",
                    }}
                >
                    <RenderAddedStudents />
                </Box>
            </Stack>
            <br></br>
            {tourOpen && (
                <Paper
                    elevation={12}
                    sx={{
                        position: "fixed",
                        right: 24,
                        bottom: 24,
                        width: { xs: "calc(100% - 32px)", sm: 380 },
                        p: 2,
                        borderRadius: 2,
                        zIndex: 1400,
                        border: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        Section {tourSection + 1} of {tourSections.length}: {tourSections[tourSection].title}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                        {tourSections[tourSection].description}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                        <Button onClick={closeTour} color="inherit">
                            Skip
                        </Button>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                                variant="outlined"
                                onClick={() => goToTourSection(tourSection - 1)}
                                disabled={tourSection === 0}
                            >
                                Back
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => goToTourSection(tourSection + 1)}
                            >
                                {tourSection === tourSections.length - 1 ? "Done" : "Next"}
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            )}
        </Box>
    );
};

export default Enroll;